<template>
  <div id="app">
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import themeManager from '@/utils/themeManager';

export default {
  name: 'App',
  computed: {
    ...mapGetters('auth', ['isAuthenticated'])
  },
  methods: {
    ...mapActions('auth', ['fetchUserPreferences', 'checkAuth']),
    
    async initializeUserPreferences() {
      try {
        await this.fetchUserPreferences();
        // 重新应用主题以确保使用最新设置
        themeManager.init();
      } catch (error) {
        console.error('初始化用户偏好设置失败:', error);
      }
    }
  },
  async created() {
    document.title = 'Insight Hub@YC';
    
    // 检查用户认证状态
    await this.checkAuth();
    
    // 初始化主题
    themeManager.init();
    
    // 如果用户已认证，获取偏好设置
    if (this.isAuthenticated) {
      await this.initializeUserPreferences();
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  color: #2c75b7;
}

.el-container {
  height: 100%;
}

.el-aside {
  background-color: #f8f9fa;
  border-right: 1px solid #e9ecef;
}

.el-header {
  background-color: #fff;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.el-footer {
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #6c757d;
}

.el-main {
  padding: 20px;
  background-color: #fff;
}
</style>